import Link from 'next/link';
import { useTranslations } from 'next-intl';
import { useState } from 'react';

import CloseIcon from '@/fo/icons/base/icons/close.svg';
import LogoIcon from '@/fo/icons/base/icons/logo.svg';
import SearchIcon from '@/fo/icons/base/icons/search.svg';
import TelegramIcon from '@/fo/icons/base/icons/tg.svg';
import VkIcon from '@/fo/icons/base/icons/vk.svg';
import { MenuItem } from '@/fo/ui/app/menu/base';

import { Items } from '../Items/Items';
import { NavigationLevel, NestedScreen } from '../NestedScreen/NestedScreen';

import { styles } from './FirstScreen.styles';

export interface FirstScreenProps {
  items: MenuItem[];
  onMenuClose: () => void;
  customVariables?: {
    [key: string]: string | unknown[];
  };
  onSearchClick?: () => void;
}

export function FirstScreen({
  items,
  onMenuClose,
  customVariables,
  onSearchClick
}: FirstScreenProps) {
  const slots = styles();
  const [navigation, setNavigation] = useState<NavigationLevel[]>([]);
  const t = useTranslations();

  const handleMenuItemClick = (
    items: MenuItem[],
    index: number,
    title: string
  ) => {
    const selectedItem = items[index];
    if (
      selectedItem &&
      selectedItem.children &&
      selectedItem.children.length > 0
    ) {
      setNavigation((prev) => [...prev, { items, index, title }]);
    }
  };

  const handleBackClick = () => {
    setNavigation((prev) => prev.slice(0, -1));
  };

  return (
    <div className={slots.base()}>
      <div className={slots.main()}>
        <div
          className={slots.close()}
          onClick={onMenuClose}
        >
          <CloseIcon className={slots.closeIcon()} />
        </div>
        <div className={slots.logo()}>
          <LogoIcon className={slots.logoIcon()} />
        </div>
        <div
          className={slots.search()}
          onClick={() => onSearchClick?.()}
        >
          <SearchIcon className={slots.searchIcon()} />
        </div>
      </div>

      <div className={slots.categories()}>
        {navigation.length === 0 ? (
          <Items
            items={items}
            props={(item, index) => ({
              onClick: () => handleMenuItemClick(items, index, item.label)
            })}
          />
        ) : (
          <NestedScreen
            navigationHistory={navigation}
            onBackClick={handleBackClick}
            onMenuItemClick={handleMenuItemClick}
          />
        )}
      </div>

      <div className={slots.contact()}>
        <div className={slots.contactDetails()}>
          {customVariables?.phone && (
            <Link
              href={`tel: ${customVariables.phone}`}
              className={slots.contactLink()}
            >
              {customVariables.phone as string}
            </Link>
          )}
          <Link
            href="/shops"
            className={slots.contactLink()}
          >
            {t('header.shops')}
          </Link>
          {customVariables?.email && (
            <Link
              href={`mailto:${customVariables.email}`}
              className={slots.contactLink()}
            >
              {customVariables.email as string}
            </Link>
          )}
        </div>
        <div className={slots.contactSocials()}>
          <Link
            href={`#`}
            className={slots.socialsLink()}
          >
            <TelegramIcon className={slots.socialIcon()} />
          </Link>
          <Link
            href={`#`}
            className={slots.socialsLink()}
          >
            <VkIcon className={slots.socialIcon()} />
          </Link>
        </div>
      </div>
    </div>
  );
}
